module.exports = __webpack_public_path__ + "img/card_middle.1c85f1b3.png";